
// State Object for AccountsRoyalty. Dont directly mutate it anywhere except the accounts/mutations.js file
export const licenceState = {
  licencesData: null,
  licencesList: null,
  licencesDetails: null,
}


